<template>
  <b-row>
    <b-col>
      <p class="mb-0"><b>{{$t('general.email')}}</b></p>
      <p>{{user.email}}</p>
      <p class="mb-0"><b>{{$t('general.name')}}</b></p>
      <p>{{fullName}}</p>
    </b-col>
    <b-col>
      <p v-if="!!user.phoneNumber" class="mb-0"><b>{{$t('general.phone')}}</b></p>
      <p v-if="!!user.phoneNumber">{{user.phoneNumber}}</p>
      <p class="mb-0"><b>{{$t('general.role')}}</b></p>
      <p>{{user.role}}</p>
    </b-col>
  </b-row>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';

  export default {
    computed: {
      ...mapState({
        user: state => state.account.user,
      }),
      ...mapGetters('account', ['fullName']),
    },
  };
</script>
